// Time-aware greeting for the Today screen header.
// Returns the *phase key* — caller resolves it through their i18n layer so
// `@busy/core` stays UI-framework-free. Phase keys mirror the demo
// (`today.morning` / `today.afternoon` / `today.evening`).
//
// Cutoffs are tuned for a barber's shift-day cadence:
//   morning   4:00 AM – 11:59 AM  → "Good morning"
//   afternoon 12:00 PM – 5:59 PM  → "Good afternoon"
//   evening   6:00 PM – 3:59 AM   → "Good evening"
// The evening band rolls through midnight to 4 AM so a late-night /
// post-shift session still reads as "winding down" rather than starting
// fresh — letting "Good evening" carry late matches how restaurants and
// hotels greet you at 11 PM.

export type GreetingPhase = 'morning' | 'afternoon' | 'evening';

export function greetingPhase(now = new Date()): GreetingPhase {
  const hour = now.getHours();
  if (hour >= 4 && hour < 12) return 'morning';
  if (hour >= 12 && hour < 18) return 'afternoon';
  return 'evening';
}

// Kept as a simple English fallback so any non-React caller (CLI, tests, edge
// functions) still gets a sensible string without wiring i18n.
export function timeAwareGreeting(now = new Date(), name?: string | null): string {
  const phrase =
    greetingPhase(now) === 'morning'
      ? 'Good morning'
      : greetingPhase(now) === 'afternoon'
      ? 'Good afternoon'
      : 'Good evening';
  return name ? `${phrase}, ${name}` : phrase;
}
